module.exports = __webpack_public_path__ + "static/img/将康活佛那个日@2x.733940e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/将康活佛那个日@2x.png
// module id = ikcW
// module chunks = 0